export { ServeCommandDeprecated } from './ServeCommandDeprecated.js';
